import React from 'react';
import PropTypes from 'prop-types';

const SummariseIcon = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={className}
    viewBox="0 0 59 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.352 27.2287V27.9787H53.102H54.216C56.3346 27.9787 58.0511 29.6964 58.1078 31.7868V38.1326C58.1078 40.2778 56.3965 41.9934 54.2779 41.9934H47.9651C45.8466 41.9934 44.1352 40.2778 44.1352 38.1326V31.7771C44.1352 29.632 45.8466 27.9163 47.9651 27.9163H49.0172H49.7672V27.1663V25.0479C49.7672 22.3877 47.6337 20.3101 45.0563 20.3101H31.4404H30.6904V21.0601V27.1663V27.9163H31.4404H32.5544C34.6729 27.9163 36.3843 29.632 36.3843 31.7771V38.1326C36.3843 40.2778 34.6729 41.9934 32.5544 41.9934H26.2416C24.123 41.9934 22.4117 40.2778 22.4117 38.1326V31.7771C22.4117 29.632 24.123 27.9163 26.2416 27.9163H27.3556H28.1056V27.1663V21.0601V20.3101H27.3556H13.7397C11.1546 20.3101 9.02869 22.4576 9.02869 25.0479V27.1663V27.9163H9.77869H10.8927C13.0113 27.9163 14.7226 29.632 14.7226 31.7771V38.1949C14.7226 40.3401 13.0113 42.0557 10.8927 42.0557H4.57989C2.46135 42.0557 0.75 40.3401 0.75 38.1949V31.8395C0.75 29.6943 2.46135 27.9787 4.57989 27.9787H5.69392H6.44392V27.2287V25.1102C6.44392 21.0334 9.70253 17.7601 13.7397 17.7601H27.3556H28.1056V17.0101V10.7793V10.0293H27.3556H24.1373C23.1606 10.0293 22.5651 8.88007 23.1867 8.05596C23.1872 8.05537 23.1876 8.05478 23.1881 8.05419L28.4395 1.21239C28.9432 0.595859 29.8527 0.595869 30.3565 1.21242L35.6079 8.05419C35.6083 8.05481 35.6088 8.05543 35.6093 8.05605C36.2308 8.88015 35.6353 10.0293 34.6587 10.0293H31.4404H30.6904V10.7793V17.0101V17.7601H31.4404H45.0563C49.0934 17.7601 52.352 21.0334 52.352 25.1102V27.2287ZM11.0758 30.5514L10.9857 30.5287H10.8927H4.57989C3.79162 30.5287 3.33477 31.1814 3.33477 31.7771V38.1326C3.33477 38.9139 3.97595 39.381 4.57989 39.381H10.8308C11.6191 39.381 12.076 38.7283 12.076 38.1326V31.7771C12.076 31.0968 11.5636 30.6742 11.0758 30.5514ZM32.7374 30.5514L32.6473 30.5287H32.5544H26.2416C25.4533 30.5287 24.9964 31.1814 24.9964 31.7771V38.1326C24.9964 38.9139 25.6376 39.381 26.2416 39.381H32.4925C33.2808 39.381 33.7376 38.7283 33.7376 38.1326V31.7771C33.7376 31.0968 33.2253 30.6742 32.7374 30.5514ZM55.2132 38.8826H55.5231V38.1326V31.7771C55.5231 30.9958 54.8819 30.5287 54.2779 30.5287H47.9651C47.1768 30.5287 46.72 31.1814 46.72 31.7771V38.1326C46.72 38.9139 47.3612 39.381 47.9651 39.381H54.216C54.6621 39.381 55.0021 39.172 55.2132 38.8826Z"
      fill="black"
      stroke="white"
      strokeWidth="1.5"
    />
    <g style={{ mixBlendMode: 'darken' }}>
      <rect
        x="5.88586"
        y="32.1042"
        width="8.02607"
        height="8.02607"
        rx="4"
        fill="#D22222"
      />
    </g>
    <g style={{ mixBlendMode: 'darken' }}>
      <rect
        x="26.7535"
        y="32.1042"
        width="8.02607"
        height="8.02607"
        rx="4"
        fill="#D22222"
      />
    </g>
    <g style={{ mixBlendMode: 'darken' }}>
      <rect
        x="48.6915"
        y="32.1042"
        width="8.02607"
        height="8.02607"
        rx="4"
        fill="#D22222"
      />
    </g>
  </svg>
);

SummariseIcon.propTypes = {
  className: PropTypes.string
};

SummariseIcon.defaultProps = {
  className: ''
};

export default SummariseIcon;
